// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1waor","requiredAsterisk":"Info_requiredAsterisk__1BZfH"};